import { gql } from '@apollo/client'

export const GET_VOE_CONTACT_EMAIL_USAGE = gql`
  query GetVoEContactEmailUsage($email: String!) {
    voeContactEmailUsage(email: $email) {
      email
      totalRecords
      contacts {
        contactId
        contactName
        email
        phoneNumber
        alternativePhones
        source
        status
        occurrenceCount
        preferred
        employerName
        dotNumber
      }
      carriers {
        carrierId
        employerName
        dotNumber
        email
      }
      verificationsOfEmployment {
        voeId
        employerName
        dotNumber
        email
        status
        clientCompanyName
        driverName
      }
      employmentExperiences {
        employmentExperienceId
        employerName
        dotNumber
        email
        driverName
      }
    }
  }
`

export const REPLACE_VOE_CONTACT_EMAIL = gql`
  mutation ReplaceVoEContactEmail(
    $currentEmail: String!
    $newEmail: String!
    $suppressPrevious: Boolean
    $contactNames: [VoEContactRenameInput!]
  ) {
    replaceVoEContactEmail(
      currentEmail: $currentEmail
      newEmail: $newEmail
      suppressPrevious: $suppressPrevious
      contactNames: $contactNames
    ) {
      currentEmail
      newEmail
      contactsUpdated
      carriersUpdated
      verificationsOfEmploymentUpdated
      employmentExperiencesUpdated
      contactsMerged
    }
  }
`

export const REMOVE_VOE_CONTACT_EMAIL = gql`
  mutation RemoveVoEContactEmail(
    $email: String!
    $suppress: Boolean
    $alsoRemove: [VoEContactPointInput!]
    $contactNames: [VoEContactRenameInput!]
  ) {
    removeVoEContactEmail(
      email: $email
      suppress: $suppress
      alsoRemove: $alsoRemove
      contactNames: $contactNames
    ) {
      email
      contactsArchived
      contactsUpdated
      carriersCleared
      verificationsCleared
    }
  }
`

export const GET_SUPPRESSED_VOE_CONTACTS = gql`
  query GetSuppressedVoEContacts($search: String) {
    suppressedVoEContacts(search: $search) {
      suppressedVoEContactId
      contactType
      value
      dotNumber
      createdAt
      suppressedBy
    }
  }
`

export const LIFT_VOE_CONTACT_SUPPRESSION = gql`
  mutation LiftVoEContactSuppression(
    $contactType: EmployerContactType!
    $value: String!
    $dotNumber: String
  ) {
    liftVoEContactSuppression(
      contactType: $contactType
      value: $value
      dotNumber: $dotNumber
    ) {
      contactType
      value
      dotNumber
    }
  }
`

export const SUPPRESS_VOE_CONTACT = gql`
  mutation SuppressVoEContact(
    $contactType: EmployerContactType!
    $value: String!
    $dotNumber: String
  ) {
    suppressVoEContact(
      contactType: $contactType
      value: $value
      dotNumber: $dotNumber
    ) {
      suppressedVoEContactId
      contactType
      value
      dotNumber
    }
  }
`
